import React, { useEffect } from 'react';
import {renderCSS, renderScript} from "../../common/util"
const Views = () => {
    useEffect(()=>{
        let isActive = true;
        const nativeFetch = window.fetch;
        const legacyGatewayOrigin = process.env.spock_api_url;
        const fetchWithLocalViewsGateway = (resource, options) => {
            const requestUrl = typeof resource === 'string' ? resource : resource && resource.url;

            if (requestUrl && requestUrl.startsWith(legacyGatewayOrigin)) {
                const localUrl = `${window.location.origin}${requestUrl.slice(legacyGatewayOrigin.length)}`;
                const localResource = typeof resource === 'string'
                    ? localUrl
                    : new Request(localUrl, resource);
                return nativeFetch.call(window, localResource, options);
            }

            return nativeFetch.call(window, resource, options);
        };
        window.fetch = fetchWithLocalViewsGateway;

        const mountViews = () => {
            if (isActive && typeof window.views_mount === 'function') {
                window.views_mount();
            }
        };
        const handleScriptError = () => {
            if (isActive) {
                console.error("Unable to load Views bundle");
            }
        };
        const viewScript = document.querySelector('script[data-id="infinity-view-dist.js"]');
        const viewStyles = document.querySelector('link[data-id="infinity-view.css"]');

        if (viewStyles === null) {
            renderCSS("infinity-view", `/css/infinity-view.min.css?v=${process.env.AppVersion}`);
        }

        if (viewScript === null) {
            renderScript("infinity-view-dist")
                .then(mountViews)
                .catch((error) => console.error("Unable to load Views bundle", error));
        } else if (typeof window.views_mount === 'function') {
            mountViews();
        } else {
            viewScript.addEventListener('load', mountViews, { once: true });
            viewScript.addEventListener('error', handleScriptError, { once: true });
        }

        return () => {
            isActive = false;
            if (window.fetch === fetchWithLocalViewsGateway) {
                window.fetch = nativeFetch;
            }
            if (viewScript) {
                viewScript.removeEventListener('load', mountViews);
                viewScript.removeEventListener('error', handleScriptError);
            }
            if (typeof window.views_unmount === 'function') {
                window.views_unmount();
            }
        };
    }, [])

    return (
        <div className="detailPage">
            <input type="hidden" name="__RequestVerificationToken" value="" readOnly />
            <div className="infinity-view-app" id={"infinity-view-app"}></div>
        </div>
    );
}

export default Views;